import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.667 2.5c0-.46.373-.833.833-.833h.833a5 5 0 0 1 5 5V12.5a.833.833 0 0 0 1.667 0V6.667a3.333 3.333 0 0 1 3.333-3.334h2.084c.46 0 .833.373.833.834V7.5c0 .46-.373.833-.833.833H15V12.5a5.833 5.833 0 0 1-11.667 0V6.894a.227.227 0 0 0-.227-.227H2.5A.833.833 0 0 1 2.5 5h.606C4.152 5 5 5.848 5 6.894V12.5a4.167 4.167 0 0 0 8.333 0V7.72c0-.582.472-1.053 1.054-1.053h.196V5h-1.25c-.92 0-1.666.746-1.666 1.667V12.5a2.5 2.5 0 0 1-5 0V6.667a3.333 3.333 0 0 0-3.334-3.334H2.5a.833.833 0 0 1-.833-.833M16.667 4.583c0-.46.373-.833.833-.833h.833a.833.833 0 0 1 0 1.667H17.5a.833.833 0 0 1-.833-.834M16.667 7.083c0-.46.373-.833.833-.833h.833a.833.833 0 0 1 0 1.667H17.5a.833.833 0 0 1-.833-.834",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }